// @flow
import React, { Component } from 'react';
import { last } from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import MenuBar from '../MenuBar';
import MenuPopout from '../MenuPopout';

import * as actions from '../../modules/actions';
import * as selectors from '../../modules/selectors';


type Props = {
	is_menu_open: boolean,
	openMenu: Function,
	closeMenu: Function,
	location: {
		pathname: string
	},
	history: Object,
	match: Object,
	selected_league: Object,
	user_id: number,
	myList: Function,
	leagues: Array<Object>,
	logout: Function,
	is_last_round_started: boolean
}

class Menu extends Component<Props> {
	componentDidMount() {
		const { myList, user_id } = this.props;

		if (user_id) {
			myList();
		}
	}

	componentDidUpdate(prev_props) {
		if(prev_props.location.pathname !== this.props.location.pathname) {
			window.scrollTo(0, 0);
		}
	}

	render() {
		const {
			is_menu_open,
			openMenu,
			closeMenu,
			location,
			selected_league,
			user_id,
			leagues,
			logout,
			is_last_round_started
		} = this.props;
		return (
			<React.Fragment>
				<MenuBar
					league={selected_league}
					leagues={leagues}
					openHamburgerMenu={openMenu}
					location={location}
					user_id={user_id}
					is_last_round_started={is_last_round_started}
				/>
				<MenuPopout
					open={is_menu_open}
					onClose={closeMenu}
					location={location}
					league={selected_league}
					user_id={user_id}
					logout={logout}
				/>
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state, props) => {
	const selected_league_id = selectors.uiSelectedLeague.getSelectedLeagueId(state);
	const rounds = selectors.rounds.getRoundsWithMatches(state);
	const is_last_round_started = rounds.length ? last(rounds).status !== 'scheduled': false;
	return {
		is_menu_open: selectors.uiMenu.isMenuOpen(state),
		user_id: state.user.data.id,
		selected_league: state.leagues.my_list.by_id[selected_league_id],
		leagues: state.leagues.my_list.ordered_ids.map(id => state.leagues.my_list.by_id[id]),
		is_last_round_started
	};
};

const mapDispatchToProps = {
	openMenu: actions.uiMenu.openHamburgerMenu,
	closeMenu: actions.uiMenu.closeHamburgerMenu,
	logout: actions.userLogout,
	myList: actions.leagueDraft.myList
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Menu));


// WEBPACK FOOTER //
// ./src/components/Menu/index.js